import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";


export class DumpsterFireGameMode extends GameMode {
    //Add your custom modes here!

    public static NORMAL_AVALANCHE: string = "NORMAL_AVALANCHE";
    public static readonly FREESPIN: string = "FREESPIN";
    public static readonly FREESPIN_AVALANCHE: string = "FREESPIN_AVALANCHE";
    public static readonly FREESPIN_SUPER: string = "FREESPIN_SUPER";
    public static readonly EXTRA_SPIN: string = "EXTRA_SPIN";
    public static readonly FREESPIN_SUPER_AVALANCHE: string = "FREESPIN_SUPER_AVALANCHE";



    /*    public static readonly FREESPIN_EAST:string = "FREESPIN_EAST";
        public static readonly FREESPIN_WEST:string = "FREESPIN_WEST";
        public static readonly FREESPIN_COAST_TO_COAST:string = "FREESPIN_COAST_TO_COAST";
        public static readonly FREESPIN_PICK:string = "FREESPIN_PICK";


        //These are only used by the client, not the server. server only use RESPIN.
        public static readonly RESPIN_EAST:string = "RESPIN_EAST";
        public static readonly RESPIN_WEST:string = "RESPIN_WEST";*/

}